import { navigate } from "gatsby";
import { motion } from "framer-motion";
import v from "@/module/Utils/variable";
import { globFunc } from "@/store";

class Util {
  static sleep = (delay) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(null);
      }, delay);
    });
  };

  static pageNavigate = async (duration, path) => {
    await Util.sleep(duration);
    await navigate(path);
  };

  static translateFromIDtoValue = (targetObject, num, lang) => {
    let result;
    Object.keys(targetObject).forEach((key) => {
      if (Number(key) === Number(num)) {
        result = targetObject[num][lang];
      }
    });
    return result;
  };

  static transformTydaIndention = (str: string, bumpy: boolean = true) => {
    const toReplace = bumpy ? "<br/>" : "";
    return str.replace(/\n/g, toReplace);
  };

  static createCubicBezier = () => {
    let cx;
    let ay;
    let by;
    let cy;
    let ax;
    let bx;
    return {
      setBezier: (x1, y1, x2, y2) => {
        cx = 3 * x1;
        bx = 3 * (x2 - x1) - cx;
        ax = 1 - cx - bx;
        cy = 3 * y1;
        by = 3 * (y2 - y1) - cy;
        ay = 1 - cy - by;
      },
      getBezier: (t) => {
        let _t;
        if (t <= 0) {
          _t = 0;
        } else if (t >= 1) {
          _t = 1;
        } else {
          let prev,
            temp = t;
          do {
            prev = temp;
            temp =
              temp -
              (temp * (cx + temp * (bx + temp * ax)) - t) /
                (cx + temp * (2 * bx + 3 * ax * temp));
          } while (Math.abs(temp - prev) > 1e-4);
          _t = temp;
        }
        return _t * (cy + _t * (by + _t * ay));
      },
    };
  };

  static getRandomInt = (max: number) => Math.floor(Math.random() * max);

  static clearBgText = () => {
    globFunc
      .getState()
      .setElement(
        <motion.span initial={{ opacity: 0 }} transition={{ duration: 0 }} />
      );
  };

  static isPC = () => (window.innerWidth > v.breakPoint ? true : false);

  static _handleTouchMove = (event) => {
    event.preventDefault();
  };

  static disableTouchActions = (target = document) => {
    target.addEventListener("touchmove", Util._handleTouchMove, {
      passive: false,
    });
  };

  static removeTouchActions = (target = document) => {
    target.removeEventListener("touchmove", Util._handleTouchMove);
  };

  static isLang = (lang: "ja" | "en") => {
    return process.env.GATSBY_LANG === lang ? true : false;
  };

  static insertStyle = (lang: "ja" | "en", style: object) => {
    return Util.isLang(lang) ? style : {};
  };

  static getDevice = (): string => {
    const ua = window.navigator.userAgent;
    let device;
    if (ua.includes("iPhone")) {
      device = "iphone";
    } else if (ua.includes("iPod")) {
      device = "ipad";
    } else if (ua.includes("Android") && ua.includes("Mobile")) {
      device = "mobile";
    } else if (ua.includes("iPad") || ua.includes("Android")) {
      device = "tablet";
    } else {
      device = "pc";
    }
    return device;
  };
}

export default Util;
